export let promptsList = [
    '{{ noun }}',
    '{{ nouns }}',
    '{{ adjective }}',
]
